import React from 'react';
import cn from 'classnames';

import {
  ActionJobDeleted,
} from '../actions';

const CardJobs = ({
  data,
  keys,
  status,
  manifest,
  onJobsChange,
  privilege
}) => {
  return (
    <div
      className={cn(
        'border-bottom p-2 cursor-pointer bg-white',
      )}
    >
      <div className="row align-items-center text-secondary">
        <div
          className={cn(status === 'new' ? 'col-11' : 'col-12')}
        >
          <div className="px-2">
            <div className="position-relative">
              <div className="table-col">
                <div className="text-uppercase">
                  {keys}. {data?.delivery_order?.shipment?.code}
                </div>
                <small className="info text-uppercase">
                  {data?.delivery_order?.shipment?.ref_code}
                </small>
                <div className="fw-bold text-uppercase">
                  {data?.origin?.name} - {data?.destination?.name}
                </div>
                <small className="info text-uppercase">
                  {data?.destination?.region
                    ? `${data?.destination?.region?.district_name}, ${data?.destination?.region?.regency_name}, ${data?.destination?.region?.province_name}`
                    : null}
                </small>
                {((manifest?.status !== 'new' && manifest?.status !== 'completed') && data?.status === undefined && privilege) && (
                  <div className="border-top ">
                    <ActionJobDeleted manifest={manifest} job={data} onJobsChange={onJobsChange} />
                  </div>
                )}
              </div>
              {data?.status !== 'new' && (
                <div className="position-absolute top-0 end-0">
                  <span className={`badge status-${data?.status}-lt`}>
                    {data?.status?.replace('_', ' ') || 'new'}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardJobs;
